import { render } from "./MyReceivedGpsDeviceTransferRequest.vue?vue&type=template&id=0ac84c28&scoped=true"
import script from "./MyReceivedGpsDeviceTransferRequest.vue?vue&type=script&lang=js"
export * from "./MyReceivedGpsDeviceTransferRequest.vue?vue&type=script&lang=js"

import "./MyReceivedGpsDeviceTransferRequest.vue?vue&type=style&index=0&id=0ac84c28&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/jahajibd.com/ia.jahajibd.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ac84c28"]])

export default __exports__